(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("hammerjs"));
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["PhotoView"] = factory(require("hammerjs"));
	else
		root["PhotoView"] = factory(root["Hammer"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_3__) {
return 


/** WEBPACK FOOTER **
 ** webpack/universalModuleDefinition
 **/